
export enum StageGroup {
  Hidden = "hidden",
  Dev = "Dev"
}
export const StageGroupDescriptions: Record<StageGroup, string> = {
  [StageGroup.Hidden]: "",
  [StageGroup.Dev]: "",
}
